import { Avatar, Box, Divider, Popover, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React from "react";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
import { THEME_COLORS } from "../../../common/themes";
import { getInitials } from "../helper";

function ProfileInfo({ anchorEl, setAnchorEl, userName, userType, onLogout }) {
  const { classes } = useStyles();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutPress = () => {
    handleClose();
    onLogout();
  };

  return (
    <Popover
      id={"profile-info"}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClose}
      classes={{ paper: classes.popper }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box display="flex" alignItems="center" pt={3} px={3}>
        <Box mr={3}>
          <Typography variant="body1" className={classes.userName}>
            {userName}
          </Typography>
          <Typography variant="caption">{userType}</Typography>
          <Divider style={{ marginTop: "1em" }} />
        </Box>
        <Avatar alt={userName} src="/broken-image.jpg" className={classes.avatar}>
          {getInitials(userName)}
        </Avatar>
      </Box>
      <Box p={2} display="flex" alignItems="center" style={{ cursor: "pointer" }} onClick={onLogoutPress}>
        <LogoutIcon className={classes.logoutIcon} />
        <Typography variant="caption">Sign out</Typography>
      </Box>
    </Popover>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  popper: {
    backgroundColor: THEME_COLORS.sideMenuBg,
  },
  logoutIcon: {
    color: THEME_COLORS.purple,
    marginRight: 10,
  },
  avatar: {
    color: THEME_COLORS.white,
    backgroundColor: THEME_COLORS.purple,
    width: 52,
    height: 52,
  },
  userName: {
    fontFamily: "NotoSansMedium",
  },
}));

export default ProfileInfo;
